export const articles = [
  {
    slug: 'park-operating-model',
    title: '诈骗园区是怎么运转的：一条被包装成"高薪工作"的产业链',
    excerpt:
      '从外面看，它像一片普通的工业园；走进去才发现，宿舍、食堂、监控和话术培训被安排在一栋栋楼里。本文拆解缅北诈骗园区最典型的四个环节。',
    category: 'park',
    categoryName: '园区内幕',
    tags: ['园区运作', '封闭管理', '产业链'],
    cover:
      'https://readdy.ai/api/search-image?query=abandoned%20industrial%20compound%20surrounded%20by%20high%20concrete%20walls%20and%20barbed%20wire%20at%20dusk%2C%20muted%20warm%20documentary%20photography%2C%20moody%20cinematic%20lighting%2C%20dark%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=1200&height=800&seq=mb-cover-park-01&orientation=landscape',
    author: '档案编辑部',
    date: '2026-08-18',
    readTime: '9 分钟',
    featured: true,
    sections: [
      {
        heading: '一、招人：把招聘包装成"出国机会"',
        paragraphs: [
          '园区的第一步从来不叫"招聘话务员"，而是被包装成"海外客服""跨境运营""游戏推广"，加上远超当地平均水平的薪资和"包吃包住包机票"的福利，精准触达急需用钱或急于改变现状的年轻人。',
          '这些岗位往往只在社交软件、熟人转发和小型招工群里出现，几乎不会出现在正规招聘平台，也不会提供可验证的公司主体。招聘人员最常说的一句话是"先把人带过去，合同落地再签"，而这恰恰是整个环节里最危险的信号。',
        ],
      },
      {
        heading: '二、接人：从口岸到园区的那段路',
        paragraphs: [
          '被招募者抵达边境后，通常会经历数次换车、换人接应，沿途被要求上交身份证件和手机，理由是"统一保管、方便办手续"。一旦完成这段路程，人的行动自由就已被实际限制。',
          '这一段的共同特征是信息断点：路线不透明、接应者身份不明、家属不知道具体去向。也因此，出境前把准确行程与联系人告知家人，是最有价值的一道防线。',
        ],
      },
      {
        heading: '三、控制：以"考核"为名的封闭管理',
        paragraphs: [
          '园区通常以业绩考核、门禁制度、押金与"赔偿路费"等方式实施控制。所谓赔偿，是把机票、食宿、介绍费逐项叠加成一个不断上涨的数字，让人即便想离开也难以承担。',
          '需要强调的是，这类"债务"在法律上并不成立，它只是让人产生无法脱身的心理压力。认清这一点，是后续求助与维权的重要前提。',
        ],
      },
      {
        heading: '四、运转：话术培训与被量化的"业绩"',
        paragraphs: [
          '进入作业环节后，新人会被安排学习统一话术脚本，按阶段完成加人、养号、引导与转化。园区关心的只有转化率与流水，个人的真实处境几乎不会被考虑。',
          '正因如此，被招募者既是受害者，也可能在不知情或被迫的情况下卷入违法环节。这也是我们反复强调"不要出境、不要尝试"的根本原因。',
        ],
      },
    ],
  },
  {
    slug: 'high-salary-trap',
    title: '高薪招聘骗局拆解：从"月入三万"到被限制人身自由',
    excerpt:
      '月入三万、报销机票、无需经验，这些看起来像天上掉馅饼的条件，其实是筛选目标的第一道门槛。本文还原高薪招聘骗局的五个关键节点。',
    category: 'scam',
    categoryName: '电诈套路',
    tags: ['高薪招聘', '境外务工', '骗局拆解'],
    cover:
      'https://readdy.ai/api/search-image?query=empty%20office%20desk%20with%20an%20old%20computer%20and%20a%20printed%20job%20advertisement%20flyer%2C%20dim%20warm%20documentary%20lighting%2C%20muted%20dark%20amber%20tones%2C%20cinematic%2C%20high%20detail&width=1200&height=800&seq=mb-cover-job-02&orientation=landscape',
    author: '档案编辑部',
    date: '2026-08-05',
    readTime: '8 分钟',
    featured: true,
    sections: [
      {
        heading: '门槛一：条件好到不需要经验',
        paragraphs: [
          '真正的高薪岗位对应的是稀缺技能，而不是"零基础、包教包会、月入三万"。当一份招聘对学历、经验和语言都几乎没有要求，却承诺远超同行的收入时，本质上是在筛选愿意相信奇迹的人。',
        ],
      },
      {
        heading: '门槛二：急，且不断催促',
        paragraphs: [
          '对方会强调"名额有限""今天就定""过了这村没这店"，用时间压力压缩你的判断空间。冷静期是识破骗局最有效的工具，凡是害怕你多想两天的机会，大多经不起推敲。',
        ],
      },
      {
        heading: '门槛三：回避合同与签证',
        paragraphs: [
          '合法的境外工作必须依托工作签证与书面合同。骗局通常以"旅游签先过去""落地再办"为由回避这两项，因为一旦落到纸面，谎言就会立刻暴露。',
        ],
      },
      {
        heading: '门槛四：要求提供证件照片',
        paragraphs: [
          '护照、身份证正反面照片一旦交出，就可能被用于注册账户、办理贷款等用途。在确认对方资质之前，任何以"先办材料"为名的证件索取都应拒绝。',
        ],
      },
      {
        heading: '门槛五：行程不透明',
        paragraphs: [
          '正规外派会明确航班、接机人与住宿信息；骗局则用"跟着走就行""到了有人接"模糊带过。行程越是说不清，风险就越高。',
        ],
      },
    ],
  },
  {
    slug: 'killing-pig-plate',
    title: '"杀猪盘"话术全流程还原：情感铺垫、诱导投资与收割离场',
    excerpt:
      '它很少一上来就要钱，而是先花上几周时间陪聊天、谈未来。等到信任建立，投资就会"顺其自然"地出现。我们把它拆成四个阶段。',
    category: 'scam',
    categoryName: '电诈套路',
    tags: ['杀猪盘', '情感诈骗', '虚假投资'],
    cover:
      'https://readdy.ai/api/search-image?query=close%20up%20of%20a%20smartphone%20screen%20glowing%20in%20a%20dark%20room%20showing%20a%20chat%20conversation%20interface%2C%20moody%20crimson%20and%20amber%20tones%2C%20cinematic%20documentary%20photography%2C%20high%20detail&width=1200&height=800&seq=mb-cover-chat-03&orientation=landscape',
    author: '档案编辑部',
    date: '2026-07-22',
    readTime: '7 分钟',
    featured: true,
    sections: [
      {
        heading: '第一阶段：养号与搭讪',
        paragraphs: [
          '对方往往拥有一个经营许久、生活气息浓厚的社交账号，头像与动态都经过精心设计。搭讪通常从无伤口的共同话题切入，比如工作压力、生活琐事或感情困惑。',
        ],
      },
      {
        heading: '第二阶段：情感铺垫',
        paragraphs: [
          '这一阶段可以持续数周甚至数月。对方会保持稳定的作息式问候，制造"这个人很靠谱"的错觉，并逐步把话题引向金钱观、未来规划与共同生活设想。',
        ],
      },
      {
        heading: '第三阶段：投资诱导',
        paragraphs: [
          '当信任足够，投资话题便会以"我最近在做一个收益不错的项目""我带你一起"的方式出现。平台往往界面精致、数据实时跳动，还会先让你小额获利并顺利提现，用来打消怀疑。',
        ],
      },
      {
        heading: '第四阶段：收割与离场',
        paragraphs: [
          '当你加大投入后，提现会开始出现障碍：需要缴税、账户异常、流水不足、需要再充值解冻。等到你意识到不对，账号已被拉黑，平台也随即关闭或换域名。',
          '记住一条：任何由"网恋对象"推荐、且无法在正规金融监管渠道查到的投资项目，都不要参与。',
        ],
      },
    ],
  },
  {
    slug: 'cross-border-route',
    title: '跨境偷渡路线揭秘：为什么"包吃包住包机票"最危险',
    excerpt:
      '偷渡行程的特点是不断换车、换人、收证件。看似贴心的全程安排，本质上是让当事人彻底失去对自身位置的掌控。',
    category: 'park',
    categoryName: '园区内幕',
    tags: ['跨境偷渡', '行程风险', '边境'],
    cover:
      'https://readdy.ai/api/search-image?query=a%20lonely%20dirt%20road%20winding%20through%20dense%20tropical%20jungle%20mountains%20at%20dawn%2C%20muted%20dark%20green%20and%20amber%20documentary%20tones%2C%20cinematic%2C%20high%20detail&width=1200&height=800&seq=mb-cover-route-04&orientation=landscape',
    author: '档案编辑部',
    date: '2026-07-09',
    readTime: '6 分钟',
    featured: false,
    sections: [
      {
        heading: '为什么全程安排反而危险',
        paragraphs: [
          '成熟的偷渡链条会主动承担所有环节，让当事人觉得"省心"。但省心的代价是：你不再需要知道路线，也就无法判断自己被带向哪里，更无法向外界描述位置。',
        ],
      },
      {
        heading: '沿途的三个典型信号',
        paragraphs: [
          '一是频繁更换交通工具与接应人；二是以统一保管为由收走证件与手机；三是要求不要对外透露行程与同行人员信息。三者出现任意一项，都应立即设法脱身并联系家人。',
        ],
      },
      {
        heading: '被限制之后还能做什么',
        paragraphs: [
          '尽量记住沿途可见的地名、建筑与车牌特征，寻找安全的时机向家人发送定位；不与管理者发生正面冲突，优先保证自身安全，再寻求官方渠道协助。',
        ],
      },
    ],
  },
  {
    slug: 'fake-investment-app',
    title: '虚假投资平台的技术外壳：假行情、假盈利、真提现难',
    excerpt:
      '很多平台的行情曲线、成交记录甚至客服对话都是后台可控的。看懂这套"技术外壳"，就能在充钱之前及时踩下刹车。',
    category: 'scam',
    categoryName: '电诈套路',
    tags: ['虚假投资', '资金盘', '提现陷阱'],
    cover:
      'https://readdy.ai/api/search-image?query=hands%20holding%20a%20smartphone%20with%20a%20rising%20stock%20chart%20reflection%20on%20a%20dark%20table%2C%20muted%20crimson%20amber%20tones%2C%20cinematic%20documentary%20photography%2C%20high%20detail&width=1200&height=800&seq=mb-cover-app-05&orientation=landscape',
    author: '档案编辑部',
    date: '2026-06-27',
    readTime: '7 分钟',
    featured: false,
    sections: [
      {
        heading: '"能看到收益"不等于"能拿到钱"',
        paragraphs: [
          '虚假平台的账户数字由后台控制，想让你看到多少收益都可以。真正的检验标准只有一个：这笔钱能否顺利、无条件地提取到自己的银行卡。',
        ],
      },
      {
        heading: '常见的三类提现障碍',
        paragraphs: [
          '第一类是费用门槛，以缴税、手续费、保证金为名要求先转账；第二类是规则门槛，突然出现"流水不足""需要升级会员"；第三类是技术门槛，页面反复报错、客服失联。',
        ],
      },
      {
        heading: '识别虚假平台的四步自查',
        paragraphs: [
          '查监管：正规平台应有可核验的金融牌照与备案信息；查主体：核实运营公司是否为真实存在的企业；查渠道：只从官方应用商店下载；查资金流向，凡是要求向个人账户或陌生对公账户转账的，一律拒绝。',
        ],
      },
    ],
  },
  {
    slug: 'victim-experience-47-days',
    title: '亲历者讲述：我在园区里的四十七天',
    excerpt:
      '这是一份经当事人授权、并做匿名处理的讲述。他描述了从被招募、被控制到最终求助脱身的完整过程。',
    category: 'victim',
    categoryName: '受害者经历',
    tags: ['亲历者', '脱身经过', '家属求助'],
    cover:
      'https://readdy.ai/api/search-image?query=view%20through%20a%20barred%20window%20into%20a%20dim%20concrete%20room%20with%20a%20simple%20wooden%20bunk%20bed%2C%20muted%20warm%20documentary%20tones%2C%20cinematic%2C%20high%20detail&width=1200&height=800&seq=mb-cover-window-06&orientation=landscape',
    author: '特约讲述 · 匿名',
    date: '2026-06-11',
    readTime: '10 分钟',
    featured: true,
    sections: [
      {
        heading: '出发前：我以为只是一次出国工作',
        paragraphs: [
          '"对方说做客服，每月底薪加提成，机票住宿都报销。我家里的情况不太好，看到这个条件就没多想。"他说，出发前唯一的犹豫，是对方一直不肯先签合同。',
        ],
      },
      {
        heading: '到达后：护照被收走的那一天',
        paragraphs: [
          '"到了地方，接我们的人说要把证件统一拿去登记，第二天就还。第二天没有还，后来也没再还过。"他说，从那天起，他才意识到自己可能走不掉了。',
        ],
      },
      {
        heading: '四十七天里：把能记的都记下来',
        paragraphs: [
          '"我不敢直接反抗，就尽量记东西——楼下的招牌、能看到的车牌、每天经过的路口。后来这些细节成了家里人报案时最有用的信息。"他提醒后来者，保留线索比冲动对抗更有意义。',
        ],
      },
      {
        heading: '事后：家属做了什么才有用',
        paragraphs: [
          '家人收到他设法发出的定位后，第一时间报了案，同时联系使领馆寻求协助，并整理了他此前的聊天记录与出境信息。两个月后，他得以返回。',
          '"别在网上找什么付费捞人的中间人，我们差点也被骗一次。"他反复强调这句话。',
        ],
      },
    ],
  },
  {
    slug: 'family-rescue-guide',
    title: '家属如何应对：失联之后的黄金处置流程',
    excerpt:
      '家人突然失联，最容易做错的就是慌乱中四处托人。本文给出一套可操作、可执行的处置步骤。',
    category: 'guide',
    categoryName: '防骗指南',
    tags: ['家属应对', '报案指引', '求助渠道'],
    cover:
      'https://readdy.ai/api/search-image?query=an%20empty%20old%20telephone%20on%20a%20wooden%20table%20beside%20a%20notebook%20and%20pen%20at%20night%2C%20warm%20dim%20lamp%20light%2C%20muted%20documentary%20tones%2C%20cinematic%2C%20high%20detail&width=1200&height=800&seq=mb-cover-family-07&orientation=landscape',
    author: '档案编辑部',
    date: '2026-05-30',
    readTime: '8 分钟',
    featured: false,
    sections: [
      {
        heading: '第一步：先固定证据，再开始找人',
        paragraphs: [
          '把聊天记录、转账凭据、对方账号、出境时间与口岸、同行人员信息全部截图并备份。这些材料在报案与后续求助中缺一不可，且越早整理越完整。',
        ],
      },
      {
        heading: '第二步：向户籍地或出境地公安机关报案',
        paragraphs: [
          '报案时说明"疑似被诱骗出境从事违法活动"，并提交整理好的证据材料。留存受案回执编号，便于后续跟进进度。',
        ],
      },
      {
        heading: '第三步：联系中国驻当地使领馆',
        paragraphs: [
          '提供当事人的身份信息、出境记录与疑似所在区域，请求协助了解情况。使领馆是官方求助渠道中非常关键的一环。',
        ],
      },
      {
        heading: '第四步：警惕"付费捞人"的二次诈骗',
        paragraphs: [
          '失联期间，家属极易被所谓"有门路""交钱就能放人"的中间人盯上。这类说法本身高度可疑，务必通过官方渠道核实，不轻易转账。',
        ],
      },
    ],
  },
  {
    slug: 'overseas-job-checklist',
    title: '反诈自检清单：出国工作前必须核实的九件事',
    excerpt:
      '把风险前置，比事后补救更有效。这份清单可以逐条打勾，任何一项无法确认，都应该慎重考虑。',
    category: 'guide',
    categoryName: '防骗指南',
    tags: ['自检清单', '出境务工', '风险核查'],
    cover:
      'https://readdy.ai/api/search-image?query=a%20clipboard%20with%20a%20blank%20checklist%20and%20a%20pen%20on%20a%20dark%20wooden%20desk%2C%20warm%20directional%20light%2C%20muted%20amber%20documentary%20tones%2C%20cinematic%2C%20high%20detail&width=1200&height=800&seq=mb-cover-check-08&orientation=landscape',
    author: '档案编辑部',
    date: '2026-05-14',
    readTime: '6 分钟',
    featured: false,
    sections: [
      {
        heading: '用工信息核实',
        paragraphs: [
          '一，能否查到招聘方的真实企业主体与注册信息；二，岗位职责与薪资结构是否书面写明；三，是否提供正规工作签证而非旅游签证。',
        ],
      },
      {
        heading: '个人安全确认',
        paragraphs: [
          '四，工作地址能否在地图上准确定位；五，是否需要交出护照原件由他人保管；六，是否被要求先行支付任何费用。以上任意一项答案为"否"或"是"，都应当停止沟通。',
        ],
      },
      {
        heading: '行前准备',
        paragraphs: [
          '七，是否已把行程、联系人告知家人；八，是否保存了驻外使领馆与当地报警电话；九，是否与家人约定了定期报平安的固定时间。把这三件事做完，再去考虑出发。',
        ],
      },
    ],
  },
];